const zIndices = {
  mobileMenuFirstNesting: 1101,
};

export default zIndices;
